import type React from 'react';
import { useTabs } from './TabsContext';
import type { TabId } from './types';

export interface TabPanelProps {
  tabId: TabId;
  children: React.ReactNode;
}

export const TabPanel = ({ children, tabId }: TabPanelProps) => {
  const { selectedTabId } = useTabs();
  return tabId !== selectedTabId ? null : (
    <section className="h-full">{children}</section>
  );
};
